// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://oyatwmwijwqgyhukqjux.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im95YXR3bXdpandxZ3lodWtxanV4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk3MTcyNzUsImV4cCI6MjA1NTI5MzI3NX0.J7gCAen_KtBez9oovbJNdjQ6f_65lry1EeG1QARRo2I";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);